import {MatrixClient, MatrixEvent, MsgType, EventType} from 'matrix-js-sdk';
import {extractLastTextMessage} from './extract-last-text-message';

export const sendReplyMessage = async (
  matrixClient: MatrixClient,
  currentMatrixRoomId: string,
  matrixEventToQuote: MatrixEvent,
  messageText: string
): Promise<void> => {
  try {
    const effectiveMatrixEventFromTextmatrixEventToQuote =
      matrixEventToQuote.getEffectiveEvent();

    const originalBody =
      effectiveMatrixEventFromTextmatrixEventToQuote.content.body || '';
    const lastTextMessageBody = extractLastTextMessage(originalBody);

    const sender = effectiveMatrixEventFromTextmatrixEventToQuote.sender;
    const eventId = effectiveMatrixEventFromTextmatrixEventToQuote.event_id;

    const replyContent = {
      body: `[[QUOTE id="${eventId}"]]<@${sender}>: ${lastTextMessageBody}[[/QUOTE]]${messageText}`,
      msgtype: MsgType.Text
    };

    await matrixClient.sendEvent(currentMatrixRoomId, EventType.RoomMessage, {
      msgtype: MsgType.Text,
      body: replyContent.body
    });
  } catch (error) {
    console.error('Failed to send the reply', error);
    throw error;
  }
};
